<template>
    <div>
        <span v-if="!hideTitle" class="tw:text-lg tw:font-semibold">Primary Theme Color</span>
        <div :class="['tw:flex tw:gap-2 tw:flex-wrap', { 'tw:pt-2': !hideTitle }]">
            <button
                v-for="primaryColor of primaryColors"
                :key="primaryColor.name"
                type="button"
                class="tw:cursor-pointer tw:w-6 tw:h-6 tw:rounded-full tw:flex tw:flex-shrink-0 tw:items-center tw:justify-center tw:p-0 tw:outline-none tw:outline-offset-1"
                :style="{
                    backgroundColor: `${primaryColor.palette['500']}`,
                    outline: layoutConfig.primary === primaryColor.name ? `2px solid ${isDarkTheme ? 'white' : 'black'}` : undefined,
                }"
                @click="updatePrimaryColor(primaryColor)"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import UserSetting from '@/models/UserSetting.js';
import { useLayout } from './composables/layout.js';
import { primaryColors } from './theme/ColorThemes.js';

defineProps({
    // When true, suppresses the built-in "Primary Theme Color" heading so a
    // parent (e.g. the profile Appearance card) can supply its own label.
    hideTitle: { type: Boolean, default: false },
});

const { layoutConfig, applyTheme, isDarkTheme } = useLayout();

const primaryColorSetting = computed(() => {
    return UserSetting.findByKey('primary_color');
});

function updatePrimaryColor(color) {
    primaryColorSetting.value.set(color.name);
    layoutConfig.primary = color.name;
    applyTheme('primary', color.name);
}
</script>
